import { render, staticRenderFns } from "./JSelectList.vue?vue&type=template&id=f673e4ec&scoped=true"
import script from "./JSelectList.vue?vue&type=script&lang=js"
export * from "./JSelectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f673e4ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f673e4ec')) {
      api.createRecord('f673e4ec', component.options)
    } else {
      api.reload('f673e4ec', component.options)
    }
    module.hot.accept("./JSelectList.vue?vue&type=template&id=f673e4ec&scoped=true", function () {
      api.rerender('f673e4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectList.vue"
export default component.exports